import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_TACHO_CORRECTION } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/corrections/$vehicleId')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_TACHO_CORRECTION, ['read'], '/unauthorized', context);
    // Same chrome as /corrections from the menu — no navigator (widget opens /corrections/$vehicleId).
    return {
      ...context,
      isNavigatorEnabled: false,
    };
  },
  component: () => null,
});
